export {};
//# sourceMappingURL=read-variable-size-integer-function.js.map